import React from "react";

// Single source of truth for the Partner Ponesi logo. The asset is a tightly cropped derivative of
// the approved `logo footer` master — rendered as-is: no wrapper, no padding, no tint, no filter.
export const BagLogo = ({ size = 40, className = "" }) => (
  <img
    src="/partner-logo-192.png?v=3"
    srcSet="/partner-logo-192.png?v=3 1x, /partner-logo-384.png?v=3 2x"
    width={size}
    height={size}
    alt="Ponesi"
    className={className}
    style={{ display: "block", objectFit: "contain", opacity: 1 }}
  />
);

// Kept as an alias so brand spots that used a container keep working without double-framing.
export const BagLogoTile = ({ size = 56, className = "" }) => (
  <BagLogo size={size} className={`shrink-0 ${className}`} />
);
